<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-copy', fontSet: 'fad'}"
	[headerText]="T.COPY_EVENT_DIALOG_TITLE | translate"
	[matDialogData]="data"
	[rect]="rect"
	class="normalDuotoneHeaderIcon"
>
	<ng-container dialogContent>
		<form [@zoomInOnEnter] [@zoomOutOnLeave] [formGroup]="newEvent" class="">
			<mat-form-field class="full-width-form" color="accent">
				<mat-label>{{ T.COPY_EVENT_DIALOG_NEW_EVENT_NAME | translate }}</mat-label>
				<input formControlName="newEventName" matInput placeholder="New Event Name" />
				@if (newEvent.get("newEventName").hasError("required")) {
					<mat-error>
						{{ T.COPY_EVENT_DIALOG_EVENT_NAME_REQUIRED | translate }}
					</mat-error>
				}
			</mat-form-field>

			<mat-form-field class="full-width-form" color="accent">
				<mat-label>{{ T.COPY_EVENT_DIALOG_NEW_START_DATE | translate }}</mat-label>
				<input (focusin)="datepicker.open()" [matDatepicker]="datepicker" formControlName="newEventDate" matInput />
				@if (newEvent.get("newEventDate")?.invalid) {
					<mat-error>
						{{ T.COPY_EVENT_DIALOG_START_DATE_INVALID | translate }}
					</mat-error>
				}
				<mat-datepicker-toggle [for]="datepicker" matSuffix />
				<mat-datepicker #datepicker color="accent">
					<mat-datepicker-actions>
						<button color="warn" mat-button matDatepickerCancel>
							{{ T.BUTTON_CANCEL | translate }}
						</button>
						<button color="accent" mat-raised-button matDatepickerApply>
							{{ T.BUTTON_OK | translate }}
						</button>
					</mat-datepicker-actions>
				</mat-datepicker>
			</mat-form-field>

			<mat-checkbox formControlName="copyEventDescription"
				>{{ T.COPY_EVENT_DIALOG_COPY_EVENT_DESCRIPTION | translate }}
			</mat-checkbox>

			<!--TODO SIMSOFT-9263: Handle Options for Copying Exam Events-->
			@if (
				data.eventType !== EventType.Exam &&
				data.eventType !== EventType.PeerPractice &&
				data.eventType !== EventType.AutomaticRecording
			) {
				<mat-checkbox formControlName="copyParticipants">{{ T.COPY_EVENT_DIALOG_COPY_PARTICIPANTS | translate }} </mat-checkbox>
			}
		</form>
	</ng-container>

	<ng-container actions>
		<sim-button
			(onClick)="cancel()"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-times'}"
			[label]="T.BUTTON_CANCEL"
			color="warn"
			style="margin-right: 15px"
		/>

		<sim-button
			(onClick)="ok()"
			[disabled]="newEvent.invalid"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-copy'}"
			[label]="T.COPY_EVENT_DIALOG_COPY_EVENT"
			color="accent"
		/>
	</ng-container>
</sim-basic-material-dialog>
